import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Auth } from "aws-amplify";
import { notification, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import "./style.css";
import logo from "../../assets/img/nbrri-logo.png";

export class ConfirmationPage extends Component {
  state = {
    username: "",
    code: "",
    isLoading: false,
    isResendLoading: false,
  };

  componentDidMount() {
    if (this.props.location.search) {
      // get username from url params
      let username = this.props.location.search.split("=")[1];

      this.setState({ username });
      console.log(username);
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  confirmCode = async (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    const { username, code } = this.state;
    try {
      await Auth.confirmSignUp(username, code);
      this.setState({ isLoading: false });
      notification.success({
        message: "Account successfully verified!",
        description: "Account verified, redirecting you in a few!",
        placement: "topRight",
        duration: 2.0,
        onClose: () => {
          this.setState({
            redirect: "/dashboard",
          });
        },
      });
    } catch (error) {
      notification.error({
        message: "Error confirming code!",
        description: error.message,
        placement: "topRight",
        duration: 2.0,
        onClose: () => {
          this.setState({ redirect: null, isLoading: false, code: "" });
        },
      });
    }
  };

  resendCode = async (e) => {
    e.preventDefault();
    this.setState({ isResendLoading: true });
    const { username } = this.state;
    try {
      await Auth.resendSignUp(username);
      this.setState({ isResendLoading: false });
      notification.success({
        message: "Code successfully sent!",
        placement: "topRight",
        duration: 1.5,
        onClose: () => {
          this.setState({
            code: "",
          });
        },
      });
    } catch (error) {
      notification.error({
        message: "Error confirming code!",
        description: error.message,
        placement: "topRight",
        duration: 1.5,
        onClose: () => {
          this.setState({ redirect: null, isResendLoading: false, code: "" });
        },
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    return (
      <React.Fragment>
        <section className="h-100">
          <div className="container h-100">
            <div className="row justify-content-md-center h-100">
              <div className="card-wrapper">
                <div className="brand">
                  <img src={logo} alt="logo" />
                </div>
                <div className="card fat">
                  <div className="card-body">
                    <h2 className="card-title bold">Check your email</h2>
                    <p>We've sent a six­ digit confirmation code</p>
                    <form
                      method="POST"
                      className="my-login-validation"
                      onSubmit={this.confirmCode}
                      noValidate=""
                    >
                      <div className="form-group">
                        <input
                          id="code"
                          className="form-control"
                          placeholder="Confirmation Code"
                          onChange={this.handleChange}
                          name="code"
                          required
                          autoFocus
                        />
                      </div>
                      <div className="form-group">&nbsp; &nbsp;</div>
                      <div
                        className="row"
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <div className="form-group m-0">
                          <button
                            type="submit"
                            className="btn btn-primary btn-block"
                          >
                            {this.state.isLoading ? (
                              <Spin
                                indicator={
                                  <LoadingOutlined style={{ fontSize: 24 }} />
                                }
                              />
                            ) : (
                              "Confirm"
                            )}
                          </button>
                        </div>
                        &nbsp; &nbsp;
                        <div className="form-group m-0 ">
                          <button
                            type="submit"
                            className="btn btn-primary btn-block"
                            onClick={this.resendCode}
                          >
                            {this.state.isResendLoading ? (
                              <Spin
                                indicator={
                                  <LoadingOutlined style={{ fontSize: 24 }} />
                                }
                              />
                            ) : (
                              "Resend Code"
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="footer">&nbsp; &nbsp; </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default ConfirmationPage;
